export default "__VITE_ASSET__De2Jk$7v__"